import {DateString} from "@globals/types/utilityTypes";
import {LocationType} from "@globals/user/interfaces";

export enum LunchSearchParams {
  Date = "date",
  Location = "location",
  PaymentGroup = "paymentGroup",
  SearchText = "searchText",
}

export enum LunchPastOrdersSortBy {
  Name = "user.first_name",
  Quantity = "item_quantity",
  CompanyPaid = "payment_group_subtotal",
}

export interface LunchFilters {
  selectedDate: DateString;
  isDayClosed: boolean;
  selectedLocation: number;
  selectedLocationData: LocationType;
  selectedPaymentGroup?: number;
  searchText?: string;
  setDate: (value: DateString) => void;
  setLocation: (value: number) => void;
  setPaymentGroup: (value: number) => void;
  setSearchText: (value: string) => void;
  menuDates: DateString[];
  isMatchFilters: ({location, paymentGroupId}: IsMatchFiltersProps) => boolean;
  isLoading: boolean;
  isError: boolean;
}

export type IsMatchFiltersProps = {
  location: LocationType;
  paymentGroupId: number;
};
